module.exports = __webpack_public_path__ + "img/transformation_bg_500.7604e692.png";